import { Link } from "react-router-dom";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";

function ClothingCollection({ componentData, getTargetUrl }) {
  return (
    <section className="clothing spacer">
      <div className="main-heading-center" style={{ marginBottom: "20px" }}>
        <h4>{componentData?.heading || ""}</h4>
      </div>
      {componentData.data?.map((data, index) => {
        return (
          <div className="img-text-center-wrap main-img mt-40" key={"clocol" +index}>
            <Link to={getTargetUrl(data)}>
              <LazyLoadImage
                alt={""}
                effect="blur"
                src={data.src || ""}
                className="img-fluid mx-auto d-block"
              />
              <span className="img-text-center">{data?.title || ""}</span>
            </Link>
          </div>
        );
      })}
    </section>
  );
}

export default ClothingCollection;
